module.exports = __webpack_public_path__ + "media/images/landing/persons/irena-kobosilova-b2ac2bb371803138d355b8368fd73dd6.png";